import Vue from "vue";
import Vuex from "vuex";
import api from "@/store/modules/api";
import armarios from "@/store/modules/armarios";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

Vue.use(Vuex);

// const BASE = process.env.VUE_APP_BASE_URL;
// const PORT = "443";
const API_BASE = "/api";

export default new Vuex.Store({
  state: {
    base_url: API_BASE,

    all_articles: [],
    orders: [],

    user: null,
    token: null,

    rol: null,
    permisos: [],
    
    esRamos: false,

    idCliente: null,
    partner_id: null,

    newOrder: null,
    usuarios: [],
    clientes: []
  },

  getters: {
    articlesInCart(state) {
      return state.all_articles.filter((a) => a.in_cart == true);
    },

    numberOfArticlesInCart(state) {
      return state.all_articles.reduce((total, a) => {
        return a.in_cart ? total + a.quantity : total;
      }, 0);
    },
    getIdCliente(state) {
      return state.idCliente;
    },
    getPartnerId(state) {
      return state.partner_id;
    },
  },

  mutations: {
    setUser(state, payload) {
      state.token = payload;
      state.user = payload ? jwtDecode(payload) : {};
    },

    setIdCliente(state, payload) {
      state.idCliente = payload;
    },
    
    setPartnerId(state, payload) {
      state.partner_id = payload;
    },

    setAllArticles(state, payload) {
      state.all_articles = payload;

      const observacion = {
        default_code: "OBSERVACION",
        name: "OBSERVACIÓN",
        qty_available: 1000,
        quantity: 1,
        observacion: true,
        in_cart: false,
      };

      state.all_articles.unshift(observacion);
    },
    addArticles(state, payload){
      state.all_articles = [
        ...state.all_articles,
        ...payload,
      ];
    },
    setOrders(state, payload) {
      state.orders = payload;
    },

    setNewOrder(state, payload) {
      state.newOrder = payload;
    }
  },

  actions: {
    // Actions for API
    async getData({ state }, { path, params }) {
      // 1. Limpiamos el path de cualquier repetición de "api" o barras al inicio.
      // Esta regex elimina: "/api/", "api/", "///", "api/api/", etc.
      const cleanPath = path.replace(/^(\/?api\/+)+|^\/+/g, '');

      // 2. Limpiamos la base_url de barras al final y también del "/api" 
      // si es que ya lo tenía, para evitar duplicados al concatenar.
      const domain = state.base_url.replace(/\/+$/, '').replace(/\/api$/, '');

      // 3. Construimos la URL final asegurando un único /api/ en medio
      const finalUrl = `${domain}/api/${cleanPath}`;

      console.log("URL generada:", finalUrl); // Para que verifiques en consola

      const response = await axios.get(finalUrl, {
        params,
      });
      
      return response.data;
    },

     // Modificar la acción postData para aceptar encabezados
    async postData({ state }, { path, body, headers }) {
      // 1. Limpiamos el path de cualquier repetición de "api" o barras iniciales
      const cleanPath = path ? path.replace(/^(\/?api\/+)+|^\/+/g, '') : '';

      // 2. Limpiamos la base_url (quitamos barras finales y el /api si ya lo trae)
      const domain = state.base_url.replace(/\/+$/, '').replace(/\/api$/, '');

      // 3. Construimos la URL con un único /api/ garantizado
      const finalUrl = `${domain}/api/${cleanPath}`;

      const response = await axios.post(
        finalUrl,
        body,
        { headers }
      );
      
      // Nota: Asegúrate de que tu backend siempre devuelva un campo .success, 
      // de lo contrario podrías devolver undefined aquí.
      return response.data.success;
    },

    async postDataWithReturn({ state }, { path, body }) {
      // console.log(`${state.base_url}/${path}`)
      const response = await axios.post(`${state.base_url}/${path}`, body, {});
      return response.data;
    },

    async putData({ state }, { path, params, body }) {
      const response = await axios.put(`${state.base_url}/${path}${params ? `/${params}` : ""}`, body, {});
      return response.data.success;
    },

    // Actions for token management
    storeToken({ commit }, payload) {
      localStorage.setItem("token", payload);
      commit("setUser", payload);
    },

    //Funcion para recoger el user al cargar la pagina de nuevo
    storeUserAfterCharge({ commit }, payload) {
      commit("setUser", payload);
    },
    storeUser({ commit }, payload) {
      localStorage.setItem("user", JSON.stringify(payload));
    },
    storeRol({state}, rol) {
      state.rol = rol
    },
    storePermisos({state}, permisos){
      state.permisos = permisos;
    },
    setEsRamos({state}, v ) {
      state.esRamos = v
    },
    retrieveToken({ commit }) {
      const token = localStorage.getItem("token");
      commit("setUser", token);
    },

    logout({ commit }) {
      commit("setUser", "");
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
    },

    storeIdCliente({ commit }, payload) {
      commit("setIdCliente", payload);
    },

    storePartnerId({ commit }, payload) {
      commit("setPartnerId", payload);
    },

    setAllArticles({ commit }, payload) {
      commit("setAllArticles", payload);
    },
    setOrders({ commit }, payload) {
      commit("setOrders", payload);
    },
    addToCart(_, payload) {
      payload?.in_cart ? (payload.quantity += payload.quantity) : (payload.in_cart = true);
    },
    addArticle({ commit }, payload){
      commit("addArticles", payload);
    },
    clearCart({ state }){
      state.all_articles.map((art) => art.in_cart = false)
    },

    removeFromCart(_, payload) {
      payload.in_cart = false;
      payload.quantity = 1;
    },

    changeNewOrder({ commit }, payload) {
      commit("setNewOrder", payload);;
    },
    setClientId({state}, idCliente) {
      console.log("Setting client ID:", idCliente);
      localStorage.setItem("clienteSeleccionado", idCliente);
      state.idCliente = idCliente;
    },

    async retrieveClientId({ state }) {
      const rawToken = localStorage.getItem("token");
  
      // Si no hay token, usar valores por defecto
      if (!rawToken || typeof rawToken !== 'string') {
        state.idCliente = 0;
        state.esRamos = false;
        state.clientes = [];
        return;
      }
  
      try {
        const decoded = jwtDecode(rawToken);
        const id_cliente = decoded.id_cliente || 0;
        const partner_id = decoded.partner_id || 0;
        const rol = decoded.rol || null;
        const permisos = decoded.permisos || [];

        state.rol = rol;
        state.permisos = permisos;
        
        // Determinar si es Ramos
        const esRamos = (id_cliente === 2000);
        state.esRamos = esRamos
  
        // Guardar idCliente
        state.idCliente = id_cliente;
        state.partner_id = partner_id;
  
        // Si es admin, cargar lista de clientes
        if (esRamos) {
          const response = await axios.post(`/api/django/portal/clientes/`);
          state.clientes = response.data.clientes || [];
        } else {
          state.clientes = []
        }
      } catch (error) {
        console.error("Error al procesar el token:", error);
        localStorage.removeItem("token"); // token inválido
        state.idCliente = 0;
        state.esRamos = false;
        state.clientes = [];
      }
    },
    setUsuarios({ state }, usuarios) {
      console.log("Setting usuarios:", usuarios);
      state.usuarios = usuarios;
      localStorage.setItem("usuarios", JSON.stringify(usuarios));
    },
    setClientes({state}, clientes){
      state.clientes=clientes
    }


  },

  modules: {
    api, armarios
  },
});
